import { NgModule } from '@angular/core';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { HeaderComponent } from './header/header.component';
import { CommonModule } from '@angular/common';
import {LanguageChangerComponent} from "./language-changer/language-changer.component";

@NgModule({
  declarations: [
    HeaderComponent,
    LanguageChangerComponent
  ],
  imports: [
    CommonModule,
    MenuModule,
    ButtonModule,
  ],
  exports: [
    HeaderComponent,
    LanguageChangerComponent
  ],
})
export class ComponentsModule {}
